import { useTranslation } from '@thoughtspot/i18n';
import { Checkbox, useCheckboxState, } from '@thoughtspot/radiant-react/widgets/checkbox';
import { Divider } from '@thoughtspot/radiant-react/widgets/divider';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { SearchBar } from '@thoughtspot/radiant-react/widgets/search-bar';
import { Toggle } from '@thoughtspot/radiant-react/widgets/toggle';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { TranslationsKeys } from '../util';
import styles from './add-users-to-groups-modal.module.scss';
export const AddUsersToGroupsModal = ({ onAddUsersToGroupsConfirm, onAddUsersToGroupsModalClose, isModalOpen, userIds = [], groupIds = [], filteredGroupList = [], groupList = [], usersData = [], updateGroupListPayload, showLoader = false, filterListData, groupsList, setFilteredGroupList, setGroupIds, setGroupList, }) => {
    const { t } = useTranslation();
    const { checkedItems: checkedGroupItems, handleChange: handleGroupChange, setCheckedItems: setCheckedGroupItems, } = useCheckboxState(groupIds, []);
    useEffect(() => {
        if (groupsList) {
            const sortedGroups = groupsList.objects.sort((a, b) => {
                const aSelected = checkedGroupItems.has(a.id);
                const bSelected = checkedGroupItems.has(b.id);
                if (aSelected && !bSelected)
                    return -1;
                if (!aSelected && bSelected)
                    return 1;
                return 0;
            });
            setFilteredGroupList(sortedGroups);
            setGroupIds(sortedGroups.map(record => ({ id: record.id })));
            setGroupList(sortedGroups);
        }
    }, [groupsList]);
    const showSelectedByGroup = (checked, data, checkedItems) => {
        const filterChecked = data.filter((item) => checkedItems.has(item.id));
        if (!filterChecked.length || data.length === filterChecked.length) {
            return;
        }
        const updatedData = checked ? [...filterChecked] : [...data];
        filterListData(updatedData);
    };
    const selectAllOrClearByGroup = (data, isClear, setCheckedItems, checkedItems) => {
        if (isClear) {
            const filteredData = data.filter((item) => checkedItems.has(item.id));
            if (filteredData.length !== data.length) {
                showSelectedByGroup(false, data, checkedItems);
            }
        }
        setCheckedItems((prevState) => {
            const newState = new Set(prevState);
            data.forEach((item) => {
                if (isClear) {
                    newState.delete(item.id);
                }
                else {
                    newState.add(item.id);
                }
            });
            return newState;
        });
    };
    const renderCheckBoxesList = (selectedCountLabel, listData, originalListData, setCheckedItems, checkedItems, handleChange, readOnlyPredicate, isSearchIncluded = false, setSearchTerm) => {
        const isSelectAllCheckboxChecked = listData.length > 0 &&
            listData.every((data) => checkedItems.has(data.id));
        return (React.createElement(React.Fragment, null,
            React.createElement(Vertical, { spacing: "a", className: styles.checkboxListTopContainer },
                isSearchIncluded && (React.createElement(SearchBar, { searchValue: "", searchPlaceholder: t('cirrus.metadata.search.placeHolder'), onSearchChange: (searchTerm) => {
                        setSearchTerm(searchTerm);
                    }, "data-testid": "search-bar-filters", className: styles.checkboxContainerSearchBox })),
                React.createElement(Horizontal, { className: styles.countFilterContainer },
                    React.createElement(Horizontal, null, `${t(TranslationsKeys[selectedCountLabel])} (${checkedItems.size})`),
                    React.createElement(Horizontal, { hAlignContent: "right" },
                        React.createElement(Typography, { variant: "p", overrideTag: "div", color: Colors.accent, className: styles.headerActionLink, onClick: () => {
                                selectAllOrClearByGroup(originalListData, false, setCheckedItems, checkedItems);
                            } }, t(TranslationsKeys.SELECT_ALL)),
                        React.createElement(Divider, { vertical: true, className: styles.headerActionLinkDivider }),
                        React.createElement(Typography, { variant: "p", overrideTag: "div", color: Colors.accent, className: styles.headerActionLink, onClick: () => {
                                selectAllOrClearByGroup(originalListData, true, setCheckedItems, checkedItems);
                            } }, t(TranslationsKeys.CLEAR))))),
            React.createElement(Vertical, { className: styles.checkboxListContainer },
                React.createElement(LoadingIndicator.Global, { hideLoader: !showLoader },
                    React.createElement(Vertical, { className: styles.checkboxList }, listData.map((item) => (React.createElement(Checkbox, { id: item.id, key: item.id, label: item.displayName, checked: checkedItems.has(item.id), isList: true, onChange: e => {
                            handleChange(e, item.id);
                        }, disabled: readOnlyPredicate &&
                            readOnlyPredicate(item.id) }))))),
                React.createElement(Vertical, { className: styles.checkboxListShowSelectedContainer },
                    React.createElement(Toggle, { checked: isSelectAllCheckboxChecked, onChange: (e) => {
                            showSelectedByGroup(e.target.checked, originalListData, checkedItems);
                        }, labelPosition: "right", "data-testid": "showSelected-groups", label: t(TranslationsKeys.SHOW_SELECTED) })))));
    };
    return (React.createElement(Modal, { size: ModalSize.SMALL, title: t(TranslationsKeys.ADD_USERS_TO_GROUPS_TITLE), isOpen: isModalOpen, confirmButton: {
            text: t(TranslationsKeys.ADD),
            onConfirm: () => {
                const clonedUserData = _.cloneDeep(usersData).map((user) => {
                    const groups = user.assignedGroups;
                    checkedGroupItems.forEach(groupId => {
                        if (!groups.includes(groupId)) {
                            groups.push(groupId);
                        }
                    });
                    return user;
                });
                onAddUsersToGroupsConfirm(clonedUserData);
            },
        }, dismissButton: {
            text: t(TranslationsKeys.CANCEL),
        }, onDismiss: onAddUsersToGroupsModalClose },
        React.createElement(Vertical, { hAlignContent: "stretch", grow: true },
            React.createElement("div", { "data-testid": "add-users-to-groups-confirmation-body" }, renderCheckBoxesList('SELECTED_GROUPS', filteredGroupList, groupList, setCheckedGroupItems, checkedGroupItems, handleGroupChange, null, true, updateGroupListPayload)))));
};
//# sourceMappingURL=add-users-to-groups-modal.js.map